import { render, staticRenderFns } from "./modal-sprint-start.vue?vue&type=template&id=3a4b32b5&scoped=true&"
import script from "./modal-sprint-start.vue?vue&type=script&lang=js&"
export * from "./modal-sprint-start.vue?vue&type=script&lang=js&"
import style0 from "./modal-sprint-start.vue?vue&type=style&index=0&id=3a4b32b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4b32b5",
  null
  
)

export default component.exports